/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_PacksInputs */

const en_for_whom_tag_packs = /** @type {(inputs: For_Whom_Tag_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packs`)
};

const pl_for_whom_tag_packs = /** @type {(inputs: For_Whom_Tag_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karnety`)
};

/**
* | output |
* | --- |
* | "Packs" |
*
* @param {For_Whom_Tag_PacksInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_packs = /** @type {((inputs?: For_Whom_Tag_PacksInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_PacksInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_packs(inputs)
	return en_for_whom_tag_packs(inputs)
});